var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipartTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 21,
    height: 21,
    transform: "translate(0 -0.15)",
    fill: "#7119bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185356",
    "data-name": "Group 185356",
    transform: "translate(0 -0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185356-2",
    "data-name": "Group 185356",
    transform: "translate(0 0.4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M2.9,14q0-3.389,0-6.778A3.571,3.571,0,0,1,6.5,3.607q6.776-.005,13.553,0a3.507,3.507,0,0,1,3.551,3.558q.005,3.409,0,6.819a10.316,10.316,0,0,1-8.437,10.148,11.038,11.038,0,0,1-1.917.174c-2.265.021-4.531.009-6.8.008A3.463,3.463,0,0,1,2.9,20.754q0-3.379,0-6.757m11.652,8.921V20.374a.934.934,0,0,0-.135,0,7.321,7.321,0,0,1-2.087.035,7.4,7.4,0,0,1-4.381-2.134.629.629,0,0,1-.178-.64.677.677,0,0,1,1.163-.245A6.061,6.061,0,0,0,13.8,19.128c.255-.018.507-.07.734-.1a9.5,9.5,0,0,1,.1-.959,3.437,3.437,0,0,1,3.409-2.793c1.3-.009,2.6,0,3.9,0h.262c.028-.355.076-.688.077-1.021.007-2.383.013-4.766,0-7.149A2.172,2.172,0,0,0,20.1,4.922q-6.819-.01-13.638,0A2.226,2.226,0,0,0,4.219,7.17q-.009,6.841,0,13.682A2.128,2.128,0,0,0,6.361,23q3.574.012,7.148,0c.346,0,.692-.048,1.045-.074m7.327-6.333H21.7c-1.2,0-2.4,0-3.594,0a2.144,2.144,0,0,0-2.228,2.243q0,1.777,0,3.553v.2c2.262-.269,5.642-3.646,6-6",
    transform: "translate(-2.742 -3.467)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M92.525,153.044c0,.205,0,.411,0,.616a.656.656,0,1,1-1.312,0q-.009-.626,0-1.252a.656.656,0,1,1,1.312,0c.005.212,0,.424,0,.636",
    transform: "translate(-86.204 -143.486)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M269.211,153.036c0,.212.005.424,0,.636a.655.655,0,0,1-1.311,0q-.01-.636,0-1.272a.655.655,0,0,1,1.311,0c.006.212,0,.424,0,.636",
    transform: "translate(-253.195 -143.487)",
    fill: "#7119bf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipartTool);
export default __webpack_public_path__ + "static/media/clipart_tool.0be66b01d81a46e2da2674892f516205.svg";
export { ForwardRef as ReactComponent };